import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userDataFilter',
})
export class userPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => 
        (row.customerName.toLowerCase().indexOf(query.toLowerCase()) > -1 || row.mobileNumber.indexOf(query.toLowerCase().replaceAll(" ","")) > -1)
      );
    }
    return array;
  }
}


